<div role="navigation" aria-label="Your Annotation Screen">
  <div role="definition" class="sub-heading mlr-6">
    {{yourAnnotationLabel}}
  </div>
  <div role="definition" class="mlr-6">
    <div class="my-1 right-panel-label-color">
      For
    </div>
    <app-location-breadcrumb></app-location-breadcrumb>
  </div>
  <div>
    <div class="flex-display mlr-6 my-1">
      <div role="navigation" aria-label="Add Annotation Image" class="cursor-pointer" tabindex="0" (click)="addAnnotations()" (keyup.enter)="addAnnotations()">
        <img src="../../../assets/icons/pencil-alt.svg" class="icon-image-para-action" alt="Add Annotation">
      </div>
      <div role="navigation" aria-label="Add Annotation" class="cursor-pointer highlight-blue ml-0-5 border-bottom-1" tabindex="0" (click)="addAnnotations()" (keyup.enter)="addAnnotations()">
         <span>{{addAnnotationLabel}}</span>
      </div>
      <div role="navigation" aria-label="See My Annotation" class="cursor-pointer highlight-blue border-bottom-1 ml-2" tabindex="0" (click)="myAnnotation()" (keyup.enter)="myAnnotation()">
        <span>{{seeMyAnnotations}}</span><mat-icon [inline]="true" class="viewInlineIcon">keyboard_arrow_right</mat-icon>
      </div>
    </div>
    <div *ngIf="labelItems.length > 0">
      <app-annotation-records role="definition" [paragraphId]="paragraphId" [labels]="labelItems" [lineBool]="lineRequired"></app-annotation-records>
    </div>
  </div>
</div>
